import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import { message } from 'ant-design-vue';

import store from '../store';
import Layout from '../layout/Layout.vue';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import NotFound from '../views/404.vue';
import Error from '../views/Error.vue';

import i18n from '../lang';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [
      // {
      //   path: '',
      //   redirect: '/home'
      // },
      {
        path: '/home',
        name: 'Home',
        component: Home
      },
      {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import('../views/AboutUs.vue')
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import('../views/Products.vue')
      },
      {
        path: '/products-inquiry',
        name: 'ProductsInquiry',
        component: () => import('../views/ProductsInquiry.vue')
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('../views/ContactUs.vue')
      },
      {
        path: '/download-center',
        name: 'DownloadCenter',
        component: () => import('../views/DownloadCenter.vue')
      },
      {
        path: '/error',
        name: 'Error',
        component: Error
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      // 登录后 整车
      {
        path: '/vehicle',
        name: 'Vehicle',
        component: () =>
          import('@/views/protected-components/vehicle/Vehicle.vue')
      },
      // 配件
      {
        path: '/part',
        name: 'Part',
        component: () => import('@/views/protected-components/part/Part.vue')
      },
      {
        path: '/part-result',
        name: 'PartResult',
        component: () =>
          import('@/views/protected-components/part/PartResult.vue')
      },
      {
        path: '/partdetail/:id',
        name: 'PartView',
        component: () =>
          import('@/views/protected-components/part/PartDetail.vue')
      },
      {
        path: '/part-detail/:id/:vehicleId',
        name: 'PartDetail',
        component: () =>
          import('@/views/protected-components/part/PartDetail.vue')
      },
      {
        path: '/diagram/:cataId/:vehicleId',
        name: 'Diagram',
        component: () => import('@/views/protected-components/part/Diagram.vue')
      },
      {
        path: '/catalogue/:vehicleId',
        name: 'Catalogue',
        component: () =>
          import('@/views/protected-components/part/Catalogue.vue')
      },
      {
        path: '/spare-part/:vehicleId',
        name: 'SparePart',
        component: () =>
          import('@/views/protected-components/part/SparePart.vue')
      },
      // 购物车
      {
        path: '/shoppingcart',
        name: 'ShoppingCart',
        component: () =>
          import('@/views/protected-components/shoppingcart/ShoppingCart.vue')
      },
      // 订单
      {
        path: '/order',
        name: 'Order',
        component: () => import('@/views/protected-components/order/Order.vue')
      },
      {
        path: '/vehicle-order-detail/:id',
        name: 'VehicleOrderDetail',
        component: () =>
          import('@/views/protected-components/order/VehicleOrderDetail.vue')
      },
      {
        path: '/vehicle-logistics-info/:id',
        name: 'VehicleLogisticsInfo',
        component: () =>
          import('@/views/protected-components/order/VehicleLogisticsInfo.vue')
      },
      {
        path: '/part-logistics-info/:id',
        name: 'PartLogisticsInfo',
        component: () =>
          import('@/views/protected-components/order/PartLogisticsInfo.vue')
      },
      {
        path: '/vehicle-logistics-detail/:id',
        name: 'VehicleLogisticsDetail',
        component: () =>
          import(
            '@/views/protected-components/order/VehicleLogisticsDetail.vue'
          )
      },
      {
        path: '/part-logistics-detail/:id',
        name: 'PartLogisticsDetail',
        component: () =>
          import('@/views/protected-components/order/PartLogisticsDetail.vue')
      },
      {
        path: '/part-order-detail/:id',
        name: 'PartOrderDetail',
        component: () =>
          import('@/views/protected-components/order/PartOrderDetail.vue')
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
      }
    ]
  }
];

const publicRoutes = [
  'Home',
  'Login',
  'AboutUs',
  'Products',
  'ProductsInquiry',
  'ContactUs',
  'DownloadCenter',
  'NotFound',
  'Error'
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  store.commit('setPreviousUrl', from.path);
  if (
    !publicRoutes.includes(to.name as string) &&
    (to.name as string) !== 'Layout' &&
    !store.state.access_token
  ) {
    message.error(i18n.global.t('error.not_loggedin'), 1, () => {
      const queryArray: string[] = [];
      const query = to.query;
      if (query) {
        Object.keys(query).forEach(k => {
          queryArray.push(`${k}=${query[k]}`);
        });
      }
      const res = queryArray.length > 0 ? `?${queryArray.join('&')}` : '';
      next('/login?redirect=' + to.path + res);
    });
  } else if (to.path === '/') {
    if (store.state.access_token) {
      next('/vehicle');
    } else {
      next('/home');
    }
  } else {
    next();
  }
});

export default router;
